import React from 'react';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvPaymentListRow = (props) => {
    const { formObject, rowKey } = props;
    // const { formObject, viewData, rowKey, index } = props;

    return (
        <ul >
                {/* <li className="uiColumnCenter uiColumn50">
                    <span>{index}</span>
                </li> */}
                <li className="uiColumnCenter uiColumn130" >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherName" }} />
                </li>
                <li className="uiColumnCenter uiColumn100" >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherDate" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherAmount" }} />
                </li>
            </ul>
    )
}

export default InvPaymentListRow